import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import "../../Assets/SCSS/abstracts/inputs.scss";

export const MuiCheckBox = (props) => <Checkbox {...props} />;

export default MuiCheckBox;
